(() => {
  'use strict';

  if (window.__PW_PRODUCT_93__) return;
  window.__PW_PRODUCT_93__ = true;

  const money = (cents) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: cents / 100 < 1 ? 3 : 2,
    maximumFractionDigits: cents / 100 < 1 ? 3 : 2
  }).format(cents / 100);

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[character]);

  const absoluteUrl = (value) => {
    try {
      return value ? new URL(value, location.href).href : '';
    } catch (error) {
      return '';
    }
  };

  function normalizeSku(root = document) {
    root.querySelectorAll('variant-sku .element-text').forEach((element) => {
      const text = (element.textContent || '').trim();
      if (/^SKU:/i.test(text)) element.textContent = text.replace(/^SKU:/i, 'Product Code:');
    });
  }

  function placeProductExtras() {
    // Preserve the real rendered elements: never clone statistics, reviews or app blocks.
    document.querySelectorAll('[data-pw-product-extras]').forEach((extras) => {
      const productMeta = extras.closest('.product-single__meta') || document;
      const buyButtons = productMeta.querySelector('block-buy-buttons');
      const proof = extras.querySelector('.pw-product-proof');
      const vat = extras.querySelector('.pw-vat-note');
      const wholesale = extras.querySelector('.pw-wholesale-card');

      if (!buyButtons) return;

      const pageContent = buyButtons.closest('.page-content--product');
      const isModal = pageContent?.dataset.modal === 'true';

      if (isModal) {
        if (proof && proof.nextElementSibling !== buyButtons) buyButtons.before(proof);
        if (vat && vat.nextElementSibling !== buyButtons) buyButtons.before(vat);
        if (wholesale && buyButtons.nextElementSibling !== wholesale) buyButtons.after(wholesale);
        extras.remove();
        return;
      }

      let assurance = productMeta.querySelector('[data-pw-product-assurance]');
      if (!assurance) {
        assurance = document.createElement('div');
        assurance.className = 'pw-product-assurance';
        assurance.setAttribute('data-pw-product-assurance', '');

        const stats = document.createElement('div');
        stats.className = 'pw-product-assurance__stats';
        const grid = document.createElement('div');
        grid.className = 'pw-product-assurance__grid';
        assurance.append(stats, grid);
      }

      // Keep proof, shipping assurance and VAT completely outside the three-
      // column price/quantity/ATC layout. Place them after Other Options.
      if (assurance.parentElement !== productMeta ||
          assurance !== productMeta.lastElementChild) {
        productMeta.append(assurance);
      }
      const stats = assurance.querySelector('.pw-product-assurance__stats');
      const grid = assurance.querySelector('.pw-product-assurance__grid');

      if (proof && stats) {
        proof.classList.remove('pw-product-proof--above-wise');
        stats.append(proof);
      }

      productMeta.querySelectorAll('.product-block--sales-point').forEach((point) => {
        if (grid && !assurance.contains(point)) grid.append(point);
      });

      const inventory = productMeta.querySelector('product-inventory.product-block--inventory-point');
      if (inventory && grid && inventory.parentElement !== grid) grid.append(inventory);

      if (vat) {
        vat.classList.add('pw-product-assurance__vat');
        assurance.append(vat);
      }
      extras.remove();
    });
  }

  function bindModal() {
    const modal = document.getElementById('PWWholesaleModal');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';

    let previousOverflow = '';
    const open = () => {
      if (!modal.hidden) return;
      previousOverflow = document.documentElement.style.overflow;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('.pw-product-modal__close')?.focus();
    };
    const close = () => {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.style.overflow = previousOverflow;
    };

    document.querySelectorAll('[data-pw-wholesale-open]').forEach((button) => {
      button.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-pw-product-modal-close]').forEach((button) => {
      button.addEventListener('click', close);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function updateUnitPrice(variant) {
    if (!variant?.price) return;
    document.querySelectorAll('[data-pw-unit-price]').forEach((element) => {
      const quantity = Number(element.dataset.boxqty || 0);
      if (quantity > 0) {
        element.textContent = `(${money(Math.round(Number(variant.price) / quantity))} per unit)`;
      }
    });
  }

  function productSheetHtml() {
    const canonical = document.querySelector('link[rel="canonical"]')?.href
      || `${location.origin}${location.pathname}`;
    const title = (
      document.querySelector('.product-single__meta h1, .block-product-title h1, h1')?.textContent
      || document.title
    ).trim();
    const sku = (
      document.querySelector('variant-sku .element-text, [data-pw-product-code], .pw-product-code')?.textContent
      || ''
    ).trim();
    const price = (
      document.querySelector('.product-single__meta .product__price, .product-single__meta [data-product-price], .product-single__meta .element-price')?.textContent
      || ''
    ).replace(/\s+/g, ' ').trim();
    const productImageNode = document.querySelector(
      '.product__main-photos img:not([aria-hidden="true"]), .product-single__media img, .product__photo img'
    );
    const logoNode = document.querySelector(
      '.site-header__logo img, .header-item--logo img, header img[alt*="Packaging"]'
    );
    const productImage = absoluteUrl(productImageNode?.currentSrc || productImageNode?.src);
    const logo = absoluteUrl(logoNode?.currentSrc || logoNode?.src);
    const rows = [...document.querySelectorAll('[data-pw-product-specs] .pw-specs__table tr')]
      .map((row) => {
        const key = row.querySelector('th')?.textContent?.trim();
        const value = row.querySelector('td')?.textContent?.trim();
        return key && value
          ? `<tr><th>${escapeHtml(key)}</th><td>${escapeHtml(value)}</td></tr>`
          : '';
      })
      .join('');
    const qr = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=0&data=${encodeURIComponent(canonical)}`;

    return `<!doctype html>
      <html lang="en">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width,initial-scale=1">
          <title>${escapeHtml(title)} · Product sheet</title>
          <style>
            @page{size:A4;margin:13mm}
            *{box-sizing:border-box}
            body{margin:0;color:#172018;background:#fff;font:14px/1.45 Arial,Helvetica,sans-serif}
            .sheet{max-width:780px;margin:0 auto}
            .head{display:flex;align-items:center;justify-content:space-between;gap:24px;padding-bottom:16px;border-bottom:4px solid #b7ef5e}
            .brand{display:flex;align-items:center;gap:12px;font-weight:900;letter-spacing:.08em;text-transform:uppercase}
            .brand img{display:block;max-width:190px;max-height:58px;object-fit:contain}
            .brand-fallback{padding:10px 14px;border-radius:8px;background:#0f2a17;color:#d4ff7c}
            .tag{padding:8px 12px;border-radius:999px;background:#efffd9;color:#24440f;font-size:12px;font-weight:800}
            .hero{display:grid;grid-template-columns:minmax(0,1fr) minmax(250px,.82fr);gap:28px;align-items:center;padding:26px 0}
            .photo{display:grid;min-height:350px;place-items:center;border:1px solid #e0e6e0;border-radius:16px;background:#fafbfa;overflow:hidden}
            .photo img{display:block;width:100%;height:350px;object-fit:contain}
            h1{margin:0 0 14px;color:#0f2a17;font-size:30px;line-height:1.12}
            .meta{display:grid;gap:8px;margin:0 0 20px;color:#536052}
            .price{color:#0f2a17;font-size:24px;font-weight:900}
            .qr{display:flex;align-items:center;gap:14px;padding:14px;border:1px solid #dce5d7;border-radius:14px;background:#fbfff6}
            .qr img{width:94px;height:94px}
            .qr strong{display:block;margin-bottom:5px;color:#0f2a17}
            .qr span{display:block;color:#5b685a;font-size:12px;word-break:break-all}
            .specs{margin-top:6px;break-inside:avoid}
            h2{margin:0 0 10px;color:#0f2a17;font-size:21px}
            table{width:100%;border-collapse:separate;border-spacing:0;overflow:hidden;border:1px solid #dce2dc;border-radius:12px}
            th,td{padding:10px 12px;border-bottom:1px solid #e7ebe7;text-align:left;vertical-align:top}
            th{width:36%;background:#f4f7f4;color:#344234}
            tr:last-child th,tr:last-child td{border-bottom:0}
            .foot{display:flex;justify-content:space-between;gap:20px;margin-top:18px;padding-top:12px;border-top:1px solid #dce2dc;color:#667166;font-size:11px}
            @media(max-width:640px){.hero{grid-template-columns:1fr}.photo,.photo img{min-height:250px;height:250px}h1{font-size:24px}}
            @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.sheet{max-width:none}}
          </style>
        </head>
        <body>
          <main class="sheet">
            <header class="head">
              <div class="brand">${logo
                ? `<img src="${escapeHtml(logo)}" alt="Packaging Wise">`
                : '<span class="brand-fallback">Packaging Wise</span>'}</div>
              <span class="tag">Product specification sheet</span>
            </header>
            <section class="hero">
              <div class="photo">${productImage
                ? `<img src="${escapeHtml(productImage)}" alt="${escapeHtml(title)}">`
                : ''}</div>
              <div>
                <h1>${escapeHtml(title)}</h1>
                <div class="meta">
                  ${sku ? `<span>${escapeHtml(sku)}</span>` : ''}
                  ${price ? `<span class="price">${escapeHtml(price)}</span>` : ''}
                </div>
                <div class="qr">
                  <img src="${escapeHtml(qr)}" alt="QR code for this product">
                  <div><strong>View this product online</strong><span>${escapeHtml(canonical)}</span></div>
                </div>
              </div>
            </section>
            <section class="specs">
              <h2>Specifications</h2>
              <table><tbody>${rows || '<tr><td>Specifications are available on the product page.</td></tr>'}</tbody></table>
            </section>
            <footer class="foot"><span>Packaging Wise</span><span>${escapeHtml(canonical)}</span></footer>
          </main>
        </body>
      </html>`;
  }

  function bindPrint() {
    document.querySelectorAll('[data-pw-print-specs]').forEach((button) => {
      if (button.dataset.pwBound) return;
      button.dataset.pwBound = '1';
      button.addEventListener('click', () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) return;
        printWindow.opener = null;
        printWindow.document.open();
        printWindow.document.write(productSheetHtml());
        printWindow.document.close();
        const printWhenReady = () => {
          const images = [...printWindow.document.images];
          const pending = images.filter((image) => !image.complete);
          if (!pending.length) {
            printWindow.focus();
            printWindow.print();
            return;
          }
          let remaining = pending.length;
          const done = () => {
            remaining -= 1;
            if (remaining <= 0) {
              printWindow.focus();
              printWindow.print();
            }
          };
          pending.forEach((image) => {
            image.addEventListener('load', done, { once: true });
            image.addEventListener('error', done, { once: true });
          });
          window.setTimeout(() => {
            if (remaining > 0 && !printWindow.closed) {
              remaining = 0;
              printWindow.focus();
              printWindow.print();
            }
          }, 2500);
        };
        if (printWindow.document.readyState === 'complete') printWhenReady();
        else printWindow.addEventListener('load', printWhenReady, { once: true });
      });
    });
  }


  // Judge.me may append a second product review summary after the original.
  // Keep the first badge and the full review widget intact.
  function hideRepeatedReviewSummary() {
    const productRoot = document.querySelector('.page-content--product');
    if (!productRoot) return;

    const badges = Array.from(productRoot.querySelectorAll('.jdgm-preview-badge'))
      .filter((badge) => !badge.closest('.grid-product, .product-recommendations, .product-card'));

    badges.forEach((badge, index) => {
      if (index === 0 || badge.dataset.pwReviewDuplicate === 'true') return;
      badge.dataset.pwReviewDuplicate = 'true';
      badge.style.setProperty('display', 'none', 'important');
      badge.setAttribute('aria-hidden', 'true');
    });
  }

  function init() {
    normalizeSku();
    placeProductExtras();
    hideRepeatedReviewSummary();
    bindModal();
    bindPrint();
  }

  document.addEventListener('variant:change', (event) => {
    normalizeSku();
    updateUnitPrice(event.detail?.variant || event.detail);
  });
  document.addEventListener('product:variant-change', (event) => {
    normalizeSku();
    updateUnitPrice(event.detail?.variant || event.detail);
  });

  let productObserver = null;
  let productTimer = null;

  const observeProductRoot = () => {
    productObserver?.disconnect();
    productObserver = null;

    const root = document.querySelector('.product-single__meta, [data-section-type="product"], .product-single');
    if (!root || !window.MutationObserver) return;

    productObserver = new MutationObserver((records) => {
      if (!records.some((record) => record.addedNodes.length || record.removedNodes.length)) return;
      window.clearTimeout(productTimer);
      productTimer = window.setTimeout(() => {
        normalizeSku(root);
        placeProductExtras();
        hideRepeatedReviewSummary();
      }, 120);
    });

    productObserver.observe(root, { childList: true, subtree: true });
  };

  const start = () => {
    init();
    observeProductRoot();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', () => {
    window.clearTimeout(productTimer);
    productTimer = window.setTimeout(start, 0);
  });
})();
